export default {
  name: 'Validation',
  data() {
    return {
      rules: {
        required: value => !!value || 'Field required',
        emailAddress: v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        passwordStrength: v =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
            v
          ) ||
          'Password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one number and one special character',
        maxLength: v => (v && v.length <= 250) || 'Max 250 characters',
        integer: v => /^[0-9]*$/.test(v) || 'Integer values only',
        decimal: v => /^[0-9]*\.?[\d*]$/.test(v) || 'Decimal values only'
      }
    }
  }
}
